import axios from "axios";
import { getAddPlaceUrl, getPlaceDetailsUrl, getPlacesUrl, getPlaceCommentsUrl, getUploadPlaceImageUrl, getEditPlaceUrl, getDeletePlaceUrl, getPlacePreferencesUrl, saveVisitUrl, getAddExtractedPlacesUrl, getExtractProgress, getExtractProgressUrl, getCopyPlaceUrl, getUpvotePlaceUrl, getDownvotePlaceUrl, getRemovePlaceVoteUrl, getPublicPlacesUrl, getPublicPlaceDetailsUrl  } from "./ServiceUrls";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default class PlaceRepository {

    async getPublicPlaces(curationId) {

        const response = await axios.get(
            `${getPublicPlacesUrl(curationId)}`,
            {
                headers: {
                }
            }
        );
        return response.data
    }

    async getPlaces(curationId, filterOptions, sortType, coordinates, distance, visits) {
        const session = await supabase.auth.getSession()
        let queryParameters = []
        if (filterOptions.length > 0) {
            queryParameters.push(`filters=${filterOptions.join(",")}`)
        }
        if (sortType != null) {
            queryParameters.push(`sort=${sortType}`)
        }
        if (coordinates != null) {
            queryParameters.push(`latitude=${coordinates.latitude}`)
            queryParameters.push(`longitude=${coordinates.longitude}`)
        }
        if (distance != null) {
            queryParameters.push(`distance=${distance}`)
        }
        if (visits.visited) {
            queryParameters.push(`hide_unvisited=true`)
        }
        if (visits.nonVisited) {
            queryParameters.push(`hide_visited=true`)
        }

        let queryString
        if (queryParameters.length > 0) {
            queryString = `?${queryParameters.join("&")}`
        } else {
            queryString = ""
        }

        const response = await axios.get(
            `${getPlacesUrl(curationId)}${queryString}`,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async quickSave(curationId, googlePlaceId) {
        const session = await supabase.auth.getSession()
        axios.post(
            getAddPlaceUrl(),
            {
                curationId: curationId,
                filterOptionIds: [],
                googlePlaceId: googlePlaceId,
                shouldAutodetectFilterOptions: true
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async savePlace(curationId, googlePlaceId, filterOptionIds) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getAddPlaceUrl(),
            {
                curationId: curationId,
                filterOptionIds: filterOptionIds,
                googlePlaceId: googlePlaceId,
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async savePlaceWithExtractedPlaces(curationId, extractedPlaces, filterOptionIds) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getAddExtractedPlacesUrl(),
            {
                curationId: curationId,
                filterOptionIds: filterOptionIds,
                places: extractedPlaces,
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getExtractProgress(curationId, progressId) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            `${getExtractProgressUrl(curationId, progressId)}`,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async updatePlace(placeId, title, googlePlaceId, filterOptionIds, description, emoji, isUsingCollectionEmoji) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getEditPlaceUrl(placeId),
            {
                title: title,
                googlePlaceId: googlePlaceId,
                filterOptionIds: filterOptionIds,
                description: description,
                emoji: emoji,
                isUsingCollectionEmoji: isUsingCollectionEmoji,
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async deletePlace(placeId) {
        const session = await supabase.auth.getSession()
        await axios.delete(
            getDeletePlaceUrl(placeId),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return
    }

    async getPlaceDetails(placeId) {
        const session = await supabase.auth.getSession()
        if (session.data.session == null) {
            const response = await axios.get(
                getPublicPlaceDetailsUrl(placeId)
            );
            return response.data
        } else {
            const response = await axios.get(
                getPlaceDetailsUrl(placeId),
                {
                    headers: {
                        'Authorization': `Bearer ${session.data.session.access_token}`
                    }
                }
            );
            return response.data
        }
    }

    async getPlacePreferences(placeId) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            `${getPlacePreferencesUrl(placeId)}`,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async savePlaceVisit(placeId) {
        const session = await supabase.auth.getSession()
        await axios.post(
            `${saveVisitUrl(placeId)}`,
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async removePlaceVisit(placeId) {
        const session = await supabase.auth.getSession()
        await axios.delete(
            `${saveVisitUrl(placeId)}`,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async copyPlace(placeId, targetCurationId) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getCopyPlaceUrl(placeId),
            {
                targetCurationId: targetCurationId
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async upvotePlace(placeId) {
        const session = await supabase.auth.getSession()
        await axios.post(
            getUpvotePlaceUrl(placeId),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async downvotePlace(placeId) {
        const session = await supabase.auth.getSession()
        await axios.post(
            getDownvotePlaceUrl(placeId),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async removePlaceVote(placeId) {
        const session = await supabase.auth.getSession()
        await axios.delete(
            getRemovePlaceVoteUrl(placeId),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async getPlaceComments(placeId) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            `${getPlaceCommentsUrl(placeId)}`,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async uploadPlaceImage(placeId, imageFile) {
        const session = await supabase.auth.getSession()
        const formData = new FormData()
        formData.append("image", imageFile)
        const response = await axios.post(
            getUploadPlaceImageUrl(placeId),
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data
    }
}
